import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Proyectos from "@/pages/Proyectos";
import ProyectosCategoria from "@/pages/ProyectosCategoria";
import Baru from "@/pages/Baru";
import Cuaderno from "@/pages/Cuaderno";
import JournalArticle from "@/pages/JournalArticle";
import Contacto from "@/pages/Contacto";

import { AuthProvider } from "@/lib/AuthContext";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProjectsList from "@/pages/admin/AdminProjectsList";
import AdminProjectForm from "@/pages/admin/AdminProjectForm";
import AdminJournalList from "@/pages/admin/AdminJournalList";
import AdminJournalForm from "@/pages/admin/AdminJournalForm";
import AdminAlliesList from "@/pages/admin/AdminAlliesList";
import AdminAllyForm from "@/pages/admin/AdminAllyForm";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App bg-[var(--pc-bg)] min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <PublicShell>
            <Routes>
              {/* Public */}
              <Route path="/" element={<Home />} />
              <Route path="/proyectos" element={<Proyectos />} />
              <Route path="/proyectos/:tipo" element={<ProyectosCategoria />} />
              <Route path="/baru" element={<Baru />} />
              <Route path="/cuaderno" element={<Cuaderno />} />
              <Route path="/cuaderno/:id" element={<JournalArticle />} />
              <Route path="/contacto" element={<Contacto />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="proyectos" element={<AdminProjectsList />} />
                <Route path="proyectos/:id" element={<AdminProjectForm />} />
                <Route path="cuaderno" element={<AdminJournalList />} />
                <Route path="cuaderno/:id" element={<AdminJournalForm />} />
                <Route path="aliados" element={<AdminAlliesList />} />
                <Route path="aliados/:id" element={<AdminAllyForm />} />
              </Route>

              <Route path="*" element={<Home />} />
            </Routes>
          </PublicShell>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#15151a",
                color: "#efe9df",
                border: "1px solid #2a2a2e",
                borderRadius: "0px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 300,
                letterSpacing: "0.06em",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
